import styled from '@emotion/styled'
import Typography from '@mui/material/Typography'
import { t } from '@lingui/core/macro'

const FullWidth = styled.div`
  width: 100%;
  margintop: 16px;
`
const NoMarginTypography = styled(Typography)`
  margin-top: 0px;
`
const TypographyBold = styled(Typography)`
  weight: 500;
`
export const FieldMapperHeader = () => {
  return (
    <FullWidth>
      <TypographyBold variant="h4">{t`Field mapping`}</TypographyBold>
      <NoMarginTypography variant="body2">
        {t`Select the fields or properties you'd like to sync with your template`}
      </NoMarginTypography>
    </FullWidth>
  )
}
